import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpClient } from '@angular/common/http';
import { HttpRequestHandler } from '../../models/http-model';
const HEADERS = {};
@Injectable()
export class UploadFileManuallyService {

  static ENV = environment;
  constructor(private httpService: HttpService, private httpClient: HttpClient) {
    //HEADERS['Content-Type'] = 'application/json';
  }

  public getListBooks(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get('assets/data/books.json', httpRequesthandler);
  }

  public uploadFile(data: any , httpRequesthandler: HttpRequestHandler): void {
    const formData = new FormData();
    formData.append('file', data.file, data.file.name);
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.upload_file, formData, httpRequesthandler);
  }

  public loadJurnal(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.load_journals, data, httpRequesthandler);
  }
  public validateThirdParty(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.validate_third_party, data, httpRequesthandler);
  }

  public validateJournal(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.validate_journal, data, httpRequesthandler);
  }
  public validateThirdErrors(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.validate_third_errors, data, httpRequesthandler);
  }
  public validateErrors(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.validate_errors, data, httpRequesthandler);
  }

  public getSequence(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(UploadFileManuallyService.ENV.environment.API.get_sequence, httpRequesthandler);
  }

  public loadThirdParty(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.load_third_party, data, httpRequesthandler);
  }
  public loadProcess(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.load_process, data, httpRequesthandler);
  }

  public getProcessDetailById(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${UploadFileManuallyService.ENV.environment.API.get_process_detail}/${data}`, httpRequesthandler);
  }

  public logProcessById(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.get_log_process, data, httpRequesthandler);
  }

  public updateProcess(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.update_process, data, httpRequesthandler);
  }

  public putProcess(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.put(UploadFileManuallyService.ENV.environment.API.update_process, data, httpRequesthandler);
  }
  public fValidateThirdParty(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.f_validate_third_party, data, httpRequesthandler);
  }

  public getProcessDetail(data, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.get_process_detail,data, httpRequesthandler);
  }

  public downloadFile(data: any) {
    let headers: any = {
      headers: HEADERS,
      responseType: 'blob'
    };
    return this.httpClient.post(UploadFileManuallyService.ENV.environment.API.download_file, data, headers);
  }
  
  public getWsdlApp(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(UploadFileManuallyService.ENV.environment.API.get_wsdl_app, httpRequesthandler);
  }
  
  public f_update_jobs_id(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.f_update_jobs_id, data, httpRequesthandler);
  }

  public loadJournalsThird(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.load_journals_third, data, httpRequesthandler);
  }

  public sendBase64(data : any, handler : HttpRequestHandler) : void{
    handler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.set_jobs_process,
                          data,
                          handler);
  }

  public get_files_process(data : any, handler : HttpRequestHandler){
    handler.headers = HEADERS;
    this.httpService.post(UploadFileManuallyService.ENV.environment.API.get_files_process,
                          data, 
                          handler);
  }
}


// WEBPACK FOOTER //
// ./src/app/core/services/upload-file-manually/upload-file-manually.service.ts